import React from 'react'
import PropTypes from 'prop-types'
import ImagePlaceholder from 'Components/ImagePlaceholder'
import { LOCKED_CONTENT_TEXT } from 'Defaults/listing'

import { _ImgPreviewBox, _Preview, _BgOverlay } from './styles'

const ImgPreview = ({ lockedText = LOCKED_CONTENT_TEXT.LOGIN_REQUIRED, locked, title, imageUrl, lowResImgUrl }) => (
  <_ImgPreviewBox>
    <ImagePlaceholder src={imageUrl} alt={title} lqip={lowResImgUrl} width={640} height={480} />

    <_Preview locked={locked}>
      <_BgOverlay />
      {
        locked
          ? <span>{lockedText}</span>
          : <span>View property</span>
      }
    </_Preview>
  </_ImgPreviewBox>
)

ImgPreview.propTypes = {
  title: PropTypes.string.isRequired,
  lockedText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  imageUrl: PropTypes.string.isRequired,
  locked: PropTypes.bool,
  lowResImgUrl: PropTypes.string,
}

export default ImgPreview
